// src/components/store/sections/newsletter/NewsletterV46OrigamiofferRoyalViolet.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV46OrigamiofferRoyalViolet(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={46}
      archKey="origami_offer"
      archLabel="Origami Ribbon Offer"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
